import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from '../icon';
import { DIRECTION } from '../../constants';
import { trackAdobeFeature } from '../../utils/trackers/adobe';

export default class SearchControls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      highlightNext: false,
      highlightPrev: false,
    };
    trackAdobeFeature('search-opened');
  }

  componentDidUpdate(prevProps) {
    this.highlightDirection(prevProps);
  }

  didSubmitNewQuery(prevProps) {
    const { query } = this.props;
    return prevProps.query !== query;
  }

  async highlightDirection(prevProps) {
    if (this.didSubmitNewQuery(prevProps)) {
      return;
    }
    const { direction, currentMatch } = this.props;
    if (prevProps.currentMatch !== currentMatch) {
      const highlight = direction === DIRECTION.ASC ? 'highlightNext' : 'highlightPrev';
      this.setState({ [highlight]: true });
      await new Promise(resolve => setTimeout(resolve, 500));
      this.setState({ [highlight]: false });
    }
  }

  render() {
    const {
      hasResults, goToNext, goToPrev, cancelSearch, isTyping,
    } = this.props;
    const { highlightNext, highlightPrev } = this.state;
    const prevNextButtons = hasResults && !isTyping
      ? [
        <button
          onClick={goToPrev}
          title="Previous result"
          type="button"
          id="search-control-prev"
          className={classnames('prev-button u-margin-s-right', {
            highlight: highlightPrev,
          })}
          key={0}
        >
          <Icon.NavigateUp className="search-icon" />
        </button>,
        <button
          onClick={goToNext}
          title="Next result"
          type="button"
          id="search-control-next"
          className={classnames('next-button u-margin-s-right', {
            highlight: highlightNext,
          })}
          key={1}
        >
          <Icon.NavigateDown className="search-icon" />
        </button>,
      ] : null;
    return (
      <div className="control-buttons move-right">
        {prevNextButtons}
        <button
          onClick={cancelSearch}
          title="Cancel search"
          type="button"
          className="close-button"
          key={2}
        >
          <Icon.Cross className="close-icon" />
        </button>
      </div>
    );
  }
}

SearchControls.propTypes = {
  isTyping: PropTypes.bool,
  goToNext: PropTypes.func.isRequired,
  goToPrev: PropTypes.func.isRequired,
  cancelSearch: PropTypes.func.isRequired,
  hasResults: PropTypes.bool.isRequired,
  currentMatch: PropTypes.number,
  direction: PropTypes.oneOf([DIRECTION.ASC, DIRECTION.DESC]),
  query: PropTypes.string,
};

SearchControls.defaultProps = {
  isTyping: false,
  currentMatch: -1,
  direction: DIRECTION.ASC,
  query: '',
};
